import { CreativeTagEvent } from '../enums';
import {
  CreativeTagTrackingPayload,
  PayloadDatas,
  EventDisplayContext
} from '../types';
import {
  PayloadBuilderStrategy,
  PayloadResult
} from './payload-builder-strategy';
import { eventByTrackingMap } from './event-by-tracking-map';
import { ParametersExtractor } from '../parameters-extractor/parameters-extractor';

export class PayloadBuilderDisplayStrategy implements PayloadBuilderStrategy {
  private creativeInitTimestamp = 0;

  constructor(private readonly parameterExtractor: ParametersExtractor) {
    this.setInitTime(Date.now());
  }

  setInitTime(timestamp: number): void {
    this.creativeInitTimestamp = timestamp;
  }

  buildPayload(
    creativeTagEvent: CreativeTagEvent,
    eventContext?: PayloadDatas & { eventContext?: EventDisplayContext },
    evt?: CustomEvent
  ): PayloadResult {
    const eventDisplayContext = this.getEventContext();

    const creativeTrackingPayload: CreativeTagTrackingPayload = {
      event: eventByTrackingMap.get(creativeTagEvent)!,
      advert_id: eventDisplayContext.impressionId,
      creative_id: String(eventDisplayContext.creativeId),
      campaign_id: eventDisplayContext.campaignId,
      is_creative_tag: true,
      details: {
        ...(evt?.detail?.timespent_seconds !== undefined && {
          timespent_seconds: evt.detail.timespent_seconds
        }),
        time_from_init: Date.now() - this.creativeInitTimestamp
      }
    };
    return creativeTrackingPayload;
  }

  getEventContext(): EventDisplayContext {
    return {
      impressionId: this.parameterExtractor.getContextParameters(
        'impressionId',
        window
      ),
      creativeId: this.parameterExtractor.getContextParameters(
        'creativeId',
        window
      ),
      campaignId: this.parameterExtractor.getContextParameters(
        'campaignId',
        window
      )
    };
  }
}
